import { render, staticRenderFns } from "./LoanAdministrator.vue?vue&type=template&id=6a36066b"
import script from "./LoanAdministrator.vue?vue&type=script&lang=js"
export * from "./LoanAdministrator.vue?vue&type=script&lang=js"
import style0 from "./LoanAdministrator.vue?vue&type=style&index=0&id=6a36066b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports